import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient } from "./ApiClient";
import { IRiskPotReportNote } from "../models/IRiskPotReport";

export class RiskPotReportNoteApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    saveRiskPotReportNote(riskPotReport: IRiskPotReportNote, success: () => void, error?: (error: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/riskPotReportNote`, riskPotReport, success, error, final);
    }

    deleteRiskPotReportNote(riskPotReportNoteId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/riskPotReportNote/delete/${riskPotReportNoteId}`, success, error, final);
    }

}